var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1719 5C19.6768 5.00023 20.9034 6.16746 20.9912 7.63965C20.9965 7.67494 21 7.71076 21 7.74707V17.2588C20.9999 18.7724 19.7338 19.9998 18.1719 20H5.82812C4.26619 19.9998 3.00006 18.7724 3 17.2588V7.74707L3.00684 7.64355C3.0073 7.64037 3.00829 7.63697 3.00879 7.63379C3.09952 6.16436 4.32517 5.00023 5.82812 5H18.1719ZM13.6445 13.4766C12.6611 14.1739 11.3389 14.1739 10.3555 13.4766L4.54297 9.35352V17.2588C4.54303 17.9467 5.11829 18.5046 5.82812 18.5049H18.1719C18.8817 18.5046 19.457 17.9467 19.457 17.2588V9.35352L13.6445 13.4766ZM5.82812 6.53125C5.25901 6.53144 4.7773 6.89935 4.6084 7.4082L11.2529 12.0068C11.6999 12.3161 12.3001 12.3161 12.7471 12.0068L19.3896 7.4082C19.2207 6.89959 18.7408 6.53144 18.1719 6.53125H5.82812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMMail);
export default __webpack_public_path__ + "static/media/icon_m_mail.d58833f4f3e240516d2a2dee14c10735.svg";
export { ForwardRef as ReactComponent };